import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { RootState } from "../../../redux/rootReducers";
import {
  CircularAvatar,
  CommonHeader,
  ErrorSuccessModal,
  Loader,
} from "../../../components/commons";
import {
  getSingleLeaveAction,
  leaveAndWFHApprovedStatusAction,
  resetSingleLeaveAndWFHApplyData,
  resetStcoToolsError,
  resetStcoToolsMessage,
  resetStcoToolsStatusCode,
  resetStcoToolsSuccess,
} from "../../../redux/stcoTools";
import { resetSession } from "../../../redux/auth";
import {
  ApplyLeaveDate,
  LeaveAndWFHStatusPayload,
  SingleApplyPayload,
} from "../../../commonTypes/stcoToolsType";
import { SingleWFHLeaveApplyDataType } from "../../../redux/stcoTools/stcoToolsType";
import Select from "react-select";
import ImagePreview from "../../../components/FileManager/Files/ImagePreview";
import { ImageDataType } from "../../../commonTypes/fileManagerTypes";
import { Pdf } from "../../../assets/images";
import { useHistory, useLocation, useParams } from "react-router-dom";

type AppProps = {
  history: any;
  token: string | null;

  singleLeaveApply: SingleWFHLeaveApplyDataType;

  dispatchResetSession: () => void;

  dispatchResetStcoToolsSuccess: () => void;
  dispatchResetStcoToolsError: () => void;
  dispatchResetStcoToolsMessage: () => void;
  dispatchResetStcoToolsStatusCode: () => void;
  fetching: boolean;
  success: number | null;
  error: string | null;
  message: string | null;
  statusCode: number | null;

  dispatchSingleWFHAndLeaveAction: (data: SingleApplyPayload) => void;

  dispatchResetSingleLeaveAndWFHApplyData: () => void;

  dispatchLeaveStatusAction: (data: LeaveAndWFHStatusPayload) => void;
};
const LeaveAndWFHDetails = ({
  token,

  success,
  error,
  statusCode,

  dispatchResetSession,
  dispatchResetStcoToolsSuccess,
  dispatchResetStcoToolsError,
  dispatchResetStcoToolsMessage,
  dispatchResetStcoToolsStatusCode,

  fetching,
  message,
  dispatchSingleWFHAndLeaveAction,
  singleLeaveApply,
  history,

  dispatchResetSingleLeaveAndWFHApplyData,
  dispatchLeaveStatusAction,
}: AppProps) => {
  let historyRedirect = useHistory();
  const idParams: any = useParams();
  const { pathname } = useLocation();
  const isWFHPage = pathname?.includes(
    "/my-space/pending-wfh/pending-wfh-details"
  );
  const search = useLocation().search;
  const notificationId = new URLSearchParams(search).get("notification_id");
  const data = singleLeaveApply;
  const casualLeaveData = data?.details?.length
    ? data?.details?.filter((el: ApplyLeaveDate, index: number) => {
        return el?.leave_type === "Casual Leave";
      })
    : [];
  const WFHData = data?.details?.length
    ? data?.details?.filter((el: ApplyLeaveDate, index: number) => {
        return el?.leave_type === "WFH";
      })
    : [];
  const unpaidLeaveData = data?.details?.length
    ? data?.details?.filter((el: ApplyLeaveDate, index: number) => {
        return (
          el?.leave_type === "Unpaid Leave" ||
          el?.leave_type === "Unpaid Leave(full time)"
        );
      })
    : [];

  const [showImagePreview, setShowImagePreview] = useState<boolean>(false);
  const [imageDetails, setImageDetails] = useState<ImageDataType>({
    imageUrl: "",
    downloadImage: "",
    fileType: "",
    finalFileName: "",
  });
  let createdName = `${
    data?.user_details?.first_name ? data?.user_details?.first_name : ""
  } ${data?.user_details?.first_name ? data?.user_details?.last_name : ""}`;
  const id =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.data &&
    history.location.state.data._id
      ? history.location.state.data._id
      : idParams?.uniqueId
      ? idParams?.uniqueId
      : "";
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatchResetStcoToolsSuccess();
    dispatchResetStcoToolsMessage();
    dispatchResetStcoToolsStatusCode();
    dispatchResetSingleLeaveAndWFHApplyData();
  }, []);

  useEffect(() => {
    if (notificationId) {
      // Scroll to the calculated position
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth", // Optional: Adds smooth scrolling
      });
    }
  }, [notificationId]);

  useEffect(() => {
    if (id) {
      if (data) {
        let finalData = {
          token,
          employee_availability_id: id,
          isPageSeen: notificationId ? true : false,
          redirectNotificationId: notificationId ? notificationId : "",
        };
        dispatchSingleWFHAndLeaveAction(finalData);
      }
    }
  }, [id]);

  const handleErrorModal = () => {
    if (success === 0) {
      if (
        statusCode === 401 &&
        error &&
        error === "You are not authorized to approve or reject this request."
      ) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="You are not authorized to approve or reject this request."
            buttonText="Home"
            statusCode={statusCode}
            onPress={() => {
              dispatchResetStcoToolsSuccess();
              dispatchResetStcoToolsError();
              dispatchResetStcoToolsMessage();
              if (!idParams) {
                history.goBack();
              }
              if (idParams) {
                historyRedirect.push({
                  pathname: `/`,
                });
              }
            }}
          />
        );
      } else if (error && statusCode === 404) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="Home"
            onPress={() => {
              historyRedirect.push({
                pathname: `/`,
              });
              dispatchResetStcoToolsSuccess();
              dispatchResetStcoToolsError();
              dispatchResetStcoToolsMessage();
            }}
          />
        );
      }

      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetStcoToolsError();
            }}
          />
        );
      }
    } else if (success === 1) {
      if (
        message &&
        message === "Leave request has been approved successfully."
      ) {
        return (
          <ErrorSuccessModal
            type="success"
            isOpen={success === 1}
            title="Success"
            message="Leave request has been approved successfully."
            buttonText="OK"
            statusCode={statusCode}
            onPress={() => {
              dispatchResetStcoToolsSuccess();
              dispatchResetStcoToolsError();
              dispatchResetStcoToolsMessage();
              if (!idParams) {
                history.goBack();
              }
              if (idParams) {
                historyRedirect.push({
                  pathname: `/my-space/pending-leaves`,
                });
              }
            }}
          />
        );
      }

      if (message && message === "Leave request has been rejected.") {
        return (
          <ErrorSuccessModal
            type="success"
            isOpen={success === 1}
            title="Success"
            message="Leave request has been rejected."
            buttonText="OK"
            statusCode={statusCode}
            onPress={() => {
              dispatchResetStcoToolsError();
              dispatchResetStcoToolsSuccess();
              dispatchResetStcoToolsMessage();
              if (!idParams) {
                history.goBack();
              }
              if (idParams) {
                historyRedirect.push({
                  pathname: `/my-space/pending-leaves`,
                });
              }
            }}
          />
        );
      }
      if (
        message &&
        message === "Work from home request has been approved successfully."
      ) {
        return (
          <ErrorSuccessModal
            type="success"
            isOpen={success === 1}
            title="Success"
            message="Work from home request has been approved successfully."
            buttonText="OK"
            statusCode={statusCode}
            onPress={() => {
              dispatchResetStcoToolsError();
              dispatchResetStcoToolsSuccess();
              dispatchResetStcoToolsMessage();
              if (!idParams) {
                history.goBack();
              }
              if (idParams) {
                historyRedirect.push({
                  pathname: `/my-space/pending-wfh`,
                });
              }
            }}
          />
        );
      }
      if (message && message === "Work from home request has been rejected.") {
        return (
          <ErrorSuccessModal
            type="success"
            isOpen={success === 1}
            title="Success"
            message="Work from home request has been rejected."
            buttonText="OK"
            statusCode={statusCode}
            onPress={() => {
              dispatchResetStcoToolsError();
              dispatchResetStcoToolsSuccess();
              dispatchResetStcoToolsMessage();
              if (!idParams) {
                history.goBack();
              }
              if (idParams) {
                historyRedirect.push({
                  pathname: `/my-space/pending-wfh`,
                });
              }
            }}
          />
        );
      }
    }
  };

  const handlePreviewImageModal = () => {
    setShowImagePreview(!showImagePreview);
  };

  const handleRequestAppoved = (id: string) => {
    let finalData = {
      token,
      employee_availability_id: id,
      request_status: 3,
    };
    localStorage.setItem(
      "leaveApproveBy",
      String(singleLeaveApply?.user_details?.user_id)
    );
    if (token) {
      dispatchLeaveStatusAction(finalData);
    }
  };
  const handleRequestReject = (id: string) => {
    let finalData = {
      token,
      employee_availability_id: id,
      request_status: 2,
    };
    localStorage.setItem(
      "leaveApproveBy",
      String(singleLeaveApply?.user_details?.user_id)
    );
    if (token) {
      dispatchLeaveStatusAction(finalData);
    }
  };

  const handleOpenPreview = (data: any) => {
    setImageDetails({
      imageUrl: blobBaseUrl + data?.file_url + "?" + blobToken,
      downloadImage: data?.file_url,
      fileType: data?.file_type,
      finalFileName: data?.file_name,
    });
    setShowImagePreview(!showImagePreview);
  };
  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;

  const previewData = (file: any) => {
    let fileNameSplited = file?.file_name.split(".");
    const finalFileName =
      file?.file_name?.length > 16
        ? `${file?.file_name.slice(0, 16)}...${
            fileNameSplited[fileNameSplited?.length - 1]
          }`
        : file?.file_name;
    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{
          backgroundColor: "#e1e1e3",
          borderRadius: "0px",
          overflow: "hidden",
          padding: "10px",
          width: "220px",
          height: "140px",
          cursor: "pointer",
        }}
        onClick={() => handleOpenPreview(file)}
      >
        <img
          src={
            file?.file_type?.toLowerCase() === "image/png" ||
            file?.file_type?.toLowerCase() === "image/jpeg" ||
            file?.file_type?.toLowerCase() === "image/jpg"
              ? blobBaseUrl + file?.file_url + "?" + blobToken
              : Pdf
          }
          alt={`leave_${finalFileName}`}
          width={file?.file_type === "application/pdf" ? "100px" : "100%"}
          height={file?.file_type === "application/pdf" ? "100px" : "100%"}
          loading="lazy"
        />
      </div>
    );
  };
  return (
    <>
      <div className="col-md-6">
        <CommonHeader
          title={`View ${isWFHPage ? "Work From Home" : "Leave"}`}
        />
      </div>
      <div className="new-table-card p-4">
        <div className="row  col-md-12 d-flex alighn-items-center mt-4">
          <div style={{ fontSize: "14px", color: "#6e7491" }}>Applied By </div>
          <div className="ml-2">
            <CircularAvatar
              name={createdName}
              image={
                data?.user_details?.profile_pic &&
                data?.user_details.profile_pic?.file_url
              }
            />
          </div>
          <div className="ml-2" style={{ fontSize: "15px", fontWeight: 600 }}>
            {createdName}
          </div>
        </div>
        <div className=" d-flex mt-3" style={{ gap: "5%" }}>
          <div style={{ width: "14%" }}>
            <div className="mb-2" style={{ color: "#6e7491" }}>
              {isWFHPage ? "Start" : "Leave"} From
            </div>
            <div>{data?.start_date}</div>
          </div>
          <div style={{ width: "14%" }}>
            <div className="mb-2" style={{ color: "#6e7491" }}>
              {isWFHPage ? "End" : "Leave"} To
            </div>
            <div>{data?.end_date}</div>
          </div>
          <div style={{ width: "14%" }}>
            <div className="mb-2" style={{ color: "#6e7491" }}>
              Applying {isWFHPage ? "WFH" : "Leave"} For
            </div>
            <div className="manufacturing-journal ">
              {data?.total_days} Days
            </div>
          </div>
          <div style={{ width: "60%" }}>
            {data?.people_to_notify?.length ? (
              <>
                <div className="mb-2" style={{ color: "#6e7491" }}>
                  People To Notify
                </div>
                <div
                  className="d-flex "
                  style={{ gap: "1%", flexWrap: "wrap" }}
                >
                  {data?.people_to_notify?.map((el: any) => {
                    let name = `${el?.first_name ? el?.first_name : ""} ${
                      el?.last_name ? el?.last_name : ""
                    }`;
                    return (
                      <div
                        className="d-flex mb-2"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <div className="ml-2">
                          <CircularAvatar
                            name={name}
                            image={el?.profile_pic && el.profile_pic?.file_url}
                          />
                        </div>
                        <div className="ml-2" style={{ fontWeight: 500 }}>
                          {name}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </>
            ) : (
              ""
            )}
          </div>
        </div>
        <div
          className="row col-md-12 mb-3 mt-4"
          style={{ fontSize: "17px", fontWeight: 500 }}
        >
          {isWFHPage ? "Work From Home Details" : "Leave Details"}
        </div>
        {casualLeaveData?.length ? (
          <div>
            <div
              style={{ fontSize: "15px", fontWeight: 500 }}
              className="mb-2 ml-2"
            >
              Casual
            </div>
            <div className="d-flex" style={{ flexWrap: "wrap" }}>
              {casualLeaveData?.length
                ? casualLeaveData?.map((el: ApplyLeaveDate, index: number) => {
                    return (
                      <>
                        <div
                          className="mb-3 ml-2 apply-date-range-container"
                          style={{
                            width: "19%",
                            justifyContent: "space-evenly",
                          }}
                        >
                          <div style={{ fontWeight: 500 }}>{el?.date}</div>
                          <div>{el?.duration_type}</div>
                        </div>
                      </>
                    );
                  })
                : ""}
            </div>
          </div>
        ) : (
          ""
        )}
        {unpaidLeaveData?.length ? (
          <div>
            <div
              style={{ fontSize: "15px", fontWeight: 500 }}
              className="mb-2 ml-2"
            >
              Unpaid
            </div>
            <div className="d-flex" style={{ flexWrap: "wrap" }}>
              {unpaidLeaveData?.length
                ? unpaidLeaveData?.map((el: ApplyLeaveDate, index: number) => {
                    return (
                      <>
                        <div
                          className="mb-3 ml-2 apply-date-range-container"
                          style={{
                            width: "19%",
                            justifyContent: "space-evenly",
                          }}
                        >
                          <div style={{ fontWeight: 500 }}>{el?.date}</div>
                          <div>{el?.duration_type}</div>
                        </div>
                      </>
                    );
                  })
                : ""}
            </div>
          </div>
        ) : (
          <>
            <div>
              <div className="d-flex" style={{ flexWrap: "wrap" }}>
                {WFHData?.length
                  ? WFHData?.map((el: ApplyLeaveDate, index: number) => {
                      return (
                        <>
                          <div
                            className="mb-3 ml-2 apply-date-range-container"
                            style={{
                              width: "19%",
                              justifyContent: "space-evenly",
                            }}
                          >
                            <div style={{ fontWeight: 500 }}>{el?.date}</div>
                            <div>{el?.duration_type}</div>
                          </div>
                        </>
                      );
                    })
                  : ""}
              </div>
            </div>
          </>
        )}
        <div className="row col-md-12 mt-3 mb-2" style={{ color: "#6e7491" }}>
          Reason
        </div>
        <div className="w-75">{data?.reason}</div>
        {data?.file_attachment?.length > 0 ? (
          <div style={{ color: "#6e7491" }} className="mt-4">
            Attached File
          </div>
        ) : (
          ""
        )}
        <div className="d-flex mt-3" style={{ gap: "3%" }}>
          {data?.file_attachment?.length > 0
            ? data?.file_attachment?.map((file: any, index: any) => {
                return <div>{previewData(file)}</div>;
              })
            : ""}
        </div>
        <div className="row col-md-12 mt-5">
          <div className="d-flex align-items-center" style={{ gap: "6%" }}>
            <div>
              <button
                className="btn btn-primary"
                style={{ whiteSpace: "nowrap" }}
                onClick={() => {
                  handleRequestAppoved(id);
                }}
                disabled={data?.request_status !== 1}
              >
                Approve Request
              </button>
            </div>
            <div>
              <button
                className="btn btn-outline"
                style={{ whiteSpace: "nowrap" }}
                onClick={() => {
                  handleRequestReject(id);
                }}
                disabled={data?.request_status !== 1}
              >
                Reject Request
              </button>
            </div>
          </div>
        </div>
      </div>
      {handleErrorModal()}
      {fetching && <Loader />}
      {showImagePreview && imageDetails?.imageUrl?.length != 0 && (
        <ImagePreview
          resetImageUrl={handlePreviewImageModal}
          imageDetails={imageDetails}
        />
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  singleLeaveApply: state.stcoTools.singleLeaveAndWFHApplyData,
  fetching: state.stcoTools.fetching,
  success: state.stcoTools.success,
  message: state.stcoTools.message,
  error: state.stcoTools.error,
  statusCode: state.stcoTools.statusCode,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSingleLeaveAndWFHApplyData: () =>
    dispatch(resetSingleLeaveAndWFHApplyData()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetStcoToolsSuccess: () => dispatch(resetStcoToolsSuccess()),
  dispatchResetStcoToolsError: () => dispatch(resetStcoToolsError()),
  dispatchResetStcoToolsMessage: () => dispatch(resetStcoToolsMessage()),
  dispatchResetStcoToolsStatusCode: () => dispatch(resetStcoToolsStatusCode()),
  dispatchSingleWFHAndLeaveAction: (data: SingleApplyPayload) =>
    dispatch(getSingleLeaveAction(data)),

  dispatchLeaveStatusAction: (data: LeaveAndWFHStatusPayload) =>
    dispatch(leaveAndWFHApprovedStatusAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LeaveAndWFHDetails);
